<template>
  <div>
    <FrameHeader/>
    
    <!-- <div v-if="!item" class="text-dark tac p-5">Loading...</div> -->

    <div class="pc-full-page page-detail">
      <div class="pc-left">
        <div class="pic-holder">
          <img :src="item.image">
        </div>
      </div>
      <div class="pc-right rel">

        <div :class="['scroll-box pb-4',{'left-bottom-space': status_show_btn_cancel || status_show_btn_buy || status_show_btn_sell}]">

          <!-- info -->
          <div class="p-4">

            <!-- like -->
            <div class="mb-3">
              <span :class="['cp' ,{'c':status_liked}]" @click="setLikeStatus()">
                <i class="fa fa-heart"></i>
                <span v-if="meta_item.like_info">
                  {{meta_item.like_info.likeNum}}
                </span>
              </span>

              <span class="float-right cp usn">
                <i 
                  v-if="item.name"
                  class="ui-icon-share" 
                  @click="showPopupShareItem()"
                ></i>
              </span>
            </div>
            
            <!--  -->
            <div>
              <h2 class="mb-1">
                {{item.name | transItemName}}
              </h2>
              <div>
                {{meta_item.nft_name}}
              </div>
              <div class="mb-3 t-gray b">
                {{1}}
                of 
                {{1}}
              </div>
            </div>

            <!-- price -->
            <div>
              <span v-if="meta_item.sell_info && meta_item.sell_info.currency">
                <b class="c">
                  {{meta_item.sell_info.buyValue || '-'}}
                  {{meta_item.sell_info.currency | uppercase}}  
                </b>
                <span v-if="meta_item.sell_info.buyValue" class="t-gray">
                  (${{meta_item.sell_info.buyValue | tokenToUsd(meta_item.sell_info.currency)}} 
                  {{lg('',{
                    en: 'USD',
                    zh: '美元',
                  })}})
                </span>
              </span>
            </div>

            <!-- des -->
            <div class="mt-4">
              {{item.description}}
            </div>

          </div>

          <!-- tabs -->
          <div>
            <div class="ui-tabset-style2 rowed-style">
              <span 
                :class="['tab',{on: on_tab === 'info'}]"
                @click="on_tab = 'info'"
                >
                {{lg('',{
                  en: 'Information',
                  zh: '信息',
                })}}
              </span>
              <span 
                :class="['tab',{on: on_tab === 'trade'}]"
                @click="on_tab = 'trade';getHistory()"
                >
                {{lg('',{
                  en: 'History',
                  zh: '交易记录',
                })}}
              </span>
            </div>
            <div class="p-4">
              
              <!-- info list -->
              <div v-if="on_tab === 'info'" class="list-owner">

                
                <div class="border-bottom py-3">
                  <div class="media">
                    <span class="ui-avatar mr-2 size-25">
                      <img :src="meta_item.owner_info.imageURL || '/static/pic/default_pic/default_avatar.jpg'">
                    </span>
                    <div class="media-body">
                      <div class="t-gray">
                        {{lg('owner')}}
                      </div>
                      <div>
                        <router-link 
                          :to="{
                            name: 'gallery',
                            query: {
                              addrfrom: meta_item.owner_info.address
                            },
                          }"
                          v-if="meta_item.owner_info && meta_item.owner_info.username" 
                          class="mr-2">
                          {{meta_item.owner_info.username}}
                        </router-link>
                        <a :href="$store.state.sitecfg.url_network_address_view + item.to" target="_blank" class="c h-c">
                          {{meta_item.owner | shortAddress}}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="border-bottom py-3">
                  <div class="media">
                    <span class="ui-avatar mr-2 size-25">
                      <img :src="creator_info.imageURL || '/static/pic/default_pic/default_avatar.jpg'">
                    </span>
                    <div class="media-body">
                      <div class="t-gray">
                        {{lg('',{
                          en: 'Creator',
                          zh: '艺术家',
                        })}}
                      </div>
                      <div>
                        <router-link 
                          :to="{
                            name: 'gallery',
                            query: {
                              addrfrom: creator_info.Creator || creator_info.address
                            },
                          }"
                          v-if="creator_info.username" 
                          class="mr-2"
                          >
                          {{creator_info.username}}
                        </router-link>
                        <a :href="$store.state.sitecfg.url_network_address_view + creator_info.Creator" target="_blank" class="c h-c">
                          {{creator_info.Creator | shortAddress}}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="border-bottom py-3">
                  <div class="media">
                    <span class="ui-avatar mr-2 size-25">
                      <img :src="collection_data.image || '/static/pic/default_pic/default_avatar.jpg'">
                    </span>
                    <div class="media-body">
                      <div class="t-gray">
                        {{lg('',{
                          en: 'Collection',
                          zh: '收藏系列',
                        })}}
                      </div>
                      <div>
                        {{meta_item.nft_name}}
                      </div>
                    </div>
                  </div>
                </div>
                
              </div>

              <!-- history list -->
              <div v-if="on_tab === 'trade' && status_loading_history" class="tac t-gray p-5">
                Loading...
              </div>
              <CpBlockHistory v-if="on_tab === 'trade' && !status_loading_history" :list_history="list_history" />
            </div>
          </div>

          <!-- 主要操作按钮 -->
          <div v-if="1 || status_show_btn_cancel || status_show_btn_buy || status_show_btn_sell" class="btn-box tac">
            <div class="box-holder"></div>

            
            <div class="box-main py-3 d-flex flex-column justify-content-center">

              <div v-if="!status_show_btn_sell && !status_show_btn_buy && !status_show_btn_cancel">
                <div>
                  <button  class="btn btn-primary btn-round cd" style="min-width: 160px;">
                    {{lg('',{
                      en: 'Currently not for sale',
                      zh: '暂时是非卖品',
                    })}}
                  </button>
                </div>
                <div class="small">
                  <div>
                    {{lg('',{
                      en: 'Tip#1: Like this item so you can easily find it later',
                      zh: '#1: 点击收藏以便下次好找',
                    })}}
                  </div>
                  <div>
                    {{lg('',{
                      en: 'Tip#2: If “Owner” left contact info in bio, contact them',
                      zh: '#2: “持有家” 在个人资料里留联系方式的话, 找他去买”',
                    })}}
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="w-100">
                  
                  <span v-if="status_show_btn_cancel && status_doing_cancel" class="ui-loading-icon size-sm"></span>
                  <button v-if="status_show_btn_cancel && !status_doing_cancel" @click="btnCancelSell()" :disabled="status_doing_cancel" class="btn btn-primary btn-round" style="min-width: 130px;">
                    {{lg('cancel')}}
                  </button>


                  <button v-if="status_show_btn_buy" @click="btnToggleBuy()" class="btn btn-primary btn-round" style="min-width: 130px;">
                    {{lg('',{
                      en: 'Buy Now',
                      zh: '我要购买',
                    })}}
                  </button>

                  <button v-if="status_show_btn_sell" @click="btnToggleSell()" class="btn btn-primary btn-round" style="min-width: 130px;">
                    {{lg('sell')}}
                  </button>

                </div>
                <div class="mt-2" v-if="status_show_btn_buy || status_show_btn_sell">
                  <span class="t-gray">
                    {{lg('service_fee')}}
                    <b>
                      2%. 
                    </b> 
                  </span>

                  <span v-if="meta_item.sell_info && meta_item.sell_info.buyValue">
                    <b class="c">
                      {{meta_item.sell_info.buyValue * fee_rate | tofixed6}}
                      {{meta_item.sell_info.currency | uppercase}}  
                    </b>
                    <span class="t-gray">
                      (${{meta_item.sell_info.buyValue* fee_rate | tokenToUsd(meta_item.sell_info.currency)}}
                      {{lg('',{
                        en: 'USD',
                        zh: '美元',
                      })}})
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <popBuy
          :cfg_status_poppad="cfg_status_poppad_buy"
          :item="item"
          :meta_item="meta_item"
        />

        <popSell
          :cfg_status_poppad="cfg_status_poppad_sell"
          :item="item"
          :meta_item="meta_item"
        />

      </div>

    </div>

  </div>
</template>

<script>
import {mapActions} from 'vuex'

import popSell from './pop_sell.vue'
import popBuy from './pop_buy.vue'

import bus from '@/bus.js'

export default {
  name: 'detail',
  components: {
    popSell,
    popBuy,
  },
  props: [],
  data() {
    return {
      // info, trade
      on_tab: 'info',

      cfg_status_poppad_sell: false,
      cfg_status_poppad_buy: false,

      status_show_btn_cancel: false,
      status_show_btn_buy: false,
      status_show_btn_sell: false,

      status_doing_cancel: false,

      item: {},
      meta_item: {
        owner_info: {},
        sell_info: {},
      },
      creator_info: {},

      collection_data: {},

      status_loading_history: false,
      list_history: [],

    }
  },
  computed: {
    fee_rate(){
      let rate = '-'
      if(this.status_show_btn_sell){
        rate = 0.98
      }
      if(this.status_show_btn_buy){
        rate = 1.02
      }
      return rate
    },

    status_liked(){
      return this.uniCheckLikeStatus(this.meta_item)
    },
  },
  watch: {
    '$store.state.web3.account'(val){
      if(val){
        this.run()
      }
    },

    '$route.params.address'(){
      this.run()
    },
    '$route.params.id'(){
      this.run()
    },
    '$route.query.owner'(){
      this.run()
    },
  },
  methods: {
    ...mapActions([
      'verifyNFTOwner',
      'cancelSell',
    ]),

    showPopupShareItem(){
      let v = this
      bus.appvue.showPopupShareItem(
        Object.assign({},v.meta_item,v.item)
      )
    },

    async setLikeStatus(){
      let v = this
      let res = await v.uniSetLikeStatus(v.meta_item, !v.status_liked)
      
      let mark = v.meta_item.like_info.likeNum += (res?1:-1)
      v.meta_item.like_info.likeNum = mark >= 0 ? mark : 0
    },

    async btnCancelSell(){
      let v = this

      var order = v.meta_item['sell_info']

      let obj = {
        address: v.$store.state.web3.account,
        address_owner: order.address,
        token_address: order.nft_address,
        token_id: order.nft_id,
        salt: order.salt,
        signature: order.signature,
        buyValue: order.buyValue,
        currency: order.currency,
        type: v.meta_item.type,
        callback: function(){
          setTimeout(function(){
            v.status_doing_cancel = false
            v.run()
          },1000)
        },
        callbackOnErr: function(){
          v.status_doing_cancel = false
        }
      }

      v.status_doing_cancel = true
      await v.cancelSell(obj)
    },

    async getData(){
      let v = this

      // let res = await v.api('query_item_meme',{id: v.$route.params.id})
      
      // let origin_url = '' + v.meta_item.url + v.meta_item.nft_id
      // let res = await fetch(origin_url)
      // res = await res.json()

      let res = await v.uniFetchItemInfo(v.meta_item)

      v.item = res

      v.getCreatorInfo()
    },

    async getCreatorInfo(){
      let v = this
      let res = await v.api('query_item_creator',{
        'nft_address': v.$route.params.address,
        'nft_id': v.$route.params.id,
      })

      if(res.code == 0){
        v.creator_info = res.data
      }

    },

    async getHistory(){
      let v = this

      await v.uniGetCurrentBlockNum()

      if(v.list_history.length === 0){
        v.status_loading_history = true
      }

      let res = await v.api('query_item_history',{
        nft_address: v.$route.params.address,
        nft_id: v.$route.params.id,
      },{
        vue: v,
        key_data: 'list_history',
      })

      v.status_loading_history = false
    },

    async getMetaData(){
      let v = this
      
      let res = await v.api('query_item_detail',{
        'nft_address': v.$route.params.address,
        'nft_id': v.$route.params.id,
        'owner': v.$route.query.owner,
      })

      if(res.code == 0){
        if(!res.data.owner_info){
          res.data.owner_info = {}
        }
        v.meta_item = res.data
      }

      // meme data
      v.getData()

      // get more info
      v.getCollectionData()

      let address_my = v.$store.state.web3.account ||  ''

      // no order
      if( (!v.meta_item.sell_info.address || !v.meta_item.sell_info.id) ){
        
        // let d_owner = v.meta_item.sell_info.address || ''
        let d_owner = v.$route.query.owner

        if( d_owner.toLowerCase() === address_my.toLowerCase() ){
          let is_owner = await v.checkIsOwner()
          console.log('is_owner',is_owner)
          if(is_owner){
            v.status_show_btn_cancel = false
            v.status_show_btn_sell = true
            v.status_show_btn_buy = false
          }
          else{
            v.status_show_btn_cancel = false
            v.status_show_btn_sell = false
            v.status_show_btn_buy = false
          }
        }
        else{
          v.status_show_btn_cancel = false
          v.status_show_btn_sell = false
          v.status_show_btn_buy = false
        }
      }
      // be order
      else{
        let address_my = (v.$store.state.web3.account || '').toLowerCase()
        let address_owner = (v.meta_item.sell_info.address ||  '').toLowerCase()

        if(address_my === address_owner){
          v.status_show_btn_cancel = true
          v.status_show_btn_buy = false
          v.status_show_btn_sell = false
        }else{
          v.status_show_btn_cancel = false
          v.status_show_btn_buy = true
          v.status_show_btn_sell = false
        }
      }

    },

    async getCollectionData(){
      let v = this

      let nft_url = v.meta_item.nft_url

      if(!nft_url){
        return
      }

      let res = await fetch(nft_url)
      res = await res.json()
      
      v.collection_data = res || {}
    },

    btnToggleBuy(val){
      let v = this

      // checklogin
      // 20201230 - no check for buy
      // if(!v.$store.state.user.local_user.address){
      //   bus.headervue.mark_sign_ui_call += 1
      //   return
      // }

      // check wallet balance
      let token_type = v.meta_item.sell_info.currency
      let price = v.meta_item.sell_info.buyValue * 1.02
      let balance = v.$store.state.web3.account_wallet.find(item => item.id === token_type) || {}
      balance = balance.num
      if(price > balance){
        bus.appvue.showPopupAddFund({
          token_type: token_type,
          nft_name: v.item.name,
        })
        return
      }

      v.cfg_status_poppad_buy = val!==undefined ? val : !v.cfg_status_poppad_buy
    },

    btnToggleSell(val){
      let v = this

      // checklogin
      // 20201230 - no check for sell
      // if(!v.$store.state.user.local_user.address){
      //   bus.headervue.mark_sign_ui_call += 1
      //   return
      // }

      v.cfg_status_poppad_sell = val!==undefined ? val : !v.cfg_status_poppad_sell
    },

    async acttionBuy(){
      let v = this
      let address_my = v.$store.state.web3.acount
      console.log(address_my)
      alert('fn acttionBuy...')
    },

    

    async checkIsOwner(){
      let v = this

      if(!v.$store.state.web3.account){
        return false
      }

      let mark = await v.verifyNFTOwner({
        address: v.$store.state.web3.account,
        NTFS_TOKEN_ADDRESS: v.$route.params.address,
        NFT_ID: v.$route.params.id,
        type: v.item.type,
      })
      console.log('checkIsOwner:',mark)
      return mark
    },

    run(){
      let v = this
      v.status_show_btn_cancel = false
      v.status_show_btn_buy = false
      v.status_show_btn_sell = false
      v.getMetaData()
    },
  },
  created() {
    let v = this

    this.run()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/vars.scss';
  
  .page-detail{
    .pc-right{
      // background-color: ;

      .scroll-box{
        max-height: 100%;
        // 
        overflow: auto;

        &.left-bottom-space{
          max-height: calc(100% - 110px);
        }
      }

      .btn-box{

        .box-holder{
          height: 110px;
        }
        .box-main{
          height: 110px;
          background: #fff;
          position: absolute;
          width: 100%;
          bottom: 0;
          left:0;
        }
      }
    }
  }

  @media(min-width: 788px){
    .page-detail{

      display: flex;
  
      .pc-left {
        flex: 1;

        .pic-holder{
          height: 100%;
        }
      }
  
      .pc-right {
        border-left: 1px solid $c_border;
        width: 440px;
      }
    }
  }

  @media(max-width: 788px){
    .page-detail{
      .pc-left{
        .pic-holder{
          min-height: 300px;
          height: 350px;
          max-height: 400px;
        }
      }

      .pc-right{
        .btn-box{
          .box-holder{
            height: 130px;
          }
          .box-main{
            position: fixed;
            bottom: 0;
            width: 100%;
            z-index: 1;
          }
        }
      }
    }
  }
</style>